module.exports = __webpack_public_path__ + "static/media/sticky_I.4d273a92.png";